export default __webpack_public_path__ + "static/2_2-6d8ae8604483df61b8fe15474048d09f.jpg";